import { ClientOrder } from './client_order';

export class Cart {
    orders: ClientOrder[] = [];
}
